import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { color } from "d3-color";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import moment from "moment";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import trueimages from "./../Asset/true-images.png";
import failimages from "./../Asset/fail-images.png";
import { ToastContainer, toast } from 'react-toastify';
import { Breadcrumbs, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Loader from "../CommonLoader";
import { Commonfun } from './../Commonfun';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import { AppContext } from "../../../Context/Context";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';


const renderDetailReport = (detail, extraMetrics) => {
  if (!detail) return null;
  return (
    <div className="ai_detail_report_body">
      {detail.found && (
        <div className="ai_detail_report_row">
          <span className="ai_detail_report_label">Found:</span>
          <span className="ai_detail_report_value">{detail.found}</span>
        </div>
      )}
      {extraMetrics && (
        <div className="ai_detail_report_row">
          <span className="ai_detail_report_label">Metrics:</span>
          <span className="ai_detail_report_value">
            {Object.entries(extraMetrics).map(([k, v]) => (
              <span key={k} style={{ marginRight: 16 }}><strong>{k}:</strong> {v}</span>
            ))}
          </span>
        </div>
      )}
      {detail.what_was_checked && (
        <div className="ai_detail_report_row">
          <span className="ai_detail_report_label">What Was Checked:</span>
          <span className="ai_detail_report_value">{detail.what_was_checked}</span>
        </div>
      )}
      {detail.expected && (
        <div className="ai_detail_report_row">
          <span className="ai_detail_report_label">Expected:</span>
          <span className="ai_detail_report_value">{detail.expected}</span>
        </div>
      )}
      {detail.impact && (
        <div className="ai_detail_report_row">
          <span className="ai_detail_report_label">Impact:</span>
          <span className="ai_detail_report_value">{detail.impact}</span>
        </div>
      )}
      {detail.issues && detail.issues.length > 0 && (
        <div className="ai_detail_report_row">
          <span className="ai_detail_report_label">Issues:</span>
          <ul className="ai_detail_report_issues">
            {detail.issues.map((issue, idx) => (
              <li key={idx}>{issue}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

const AccordionRow = ({ panelId, label, data, extraMetrics, isExpanded, onToggle }) => (
  <Accordion expanded={isExpanded} onChange={() => onToggle(panelId)}>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls={`${panelId}-content`}
      id={`${panelId}-header`}
    >
      <Typography sx={{ width: '33%', flexShrink: 0 }}>{label}</Typography>
      <Typography sx={{ color: 'text.secondary', flex: 1 }}>{data?.message}</Typography>
      <Typography sx={{ color: 'text.secondary', marginLeft: 'auto', paddingLeft: '16px' }}>
        {data?.result
          ? <img src={trueimages} className="view_per_img" alt="pass" />
          : <img src={failimages} className="view_per_img" alt="fail" />
        }
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      {renderDetailReport(data?.detail_report, extraMetrics)}
    </AccordionDetails>
  </Accordion>
);


const AiReadinessDetail = () => {
  let querystring = useParams();
  const [expanded, setExpanded] = React.useState([]);
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);

  const ItemId = querystring.id;
  const esodata = useSelector((state) => state);

  const [jobDate, SetjobDate] = useState("");
  const ApiToken = esodata.apiauthkey.value;
  const [loading, setLoading] = useState(false);

  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [DetailRunReportPopShow, SetDetailRunReportPopShow] = useState();

  const [isDownloading, setIsDownloading] = useState(false);
  const navigate = useNavigate();

  const [crawlabilityData, setCrawlabilityData] = useState([]);
  const [semanticStructure, setSemanticStructure] = useState([]);
  const [contentClarity, setContentClarity] = useState([]);
  const [structuredData, setStructuredData] = useState([]);
  const [pageRendering, setPageRendering] = useState([]);
  const [authorityContext, setAuthorityContext] = useState([]);
  const [linkUrl, setLinkUrl] = useState([]);

  const handleChange = (panel) => {
    setExpanded((prev) =>
      prev.includes(panel) ? prev.filter((p) => p !== panel) : [...prev, panel]
    );
  };

  const rowProps = (panelId) => ({
    isExpanded: expanded.includes(panelId),
    onToggle: handleChange,
  });

  const AccessbilityScoreDetail = async () => {
    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}customized_report/ai_readiness_report_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&id=${ItemId}`,
      { headers: { Authorization: `${ApiToken}` } }
    ).catch((error) => {
      if (error?.response?.status === 599 || error?.response?.status === 400 || error?.response?.status === 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error);
      } else if (error?.code === "ERR_NETWORK" || error?.response?.status === 404) {
        navigate('/errorpages');
      }
    });
    if (datavalue?.data?.result) {
      const dataval = datavalue?.data?.result;
      if (datavalue?.data?.job_date)
        SetjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));
      else
        SetjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"));
      setLinkUrl(datavalue?.data.result.link__url);
      setCrawlabilityData(dataval.crawlability);
      setSemanticStructure(dataval.semantic_structure);
      setContentClarity(dataval.content_clarity);
      setStructuredData(dataval.structured_data);
      setPageRendering(dataval.page_rendering);
      setAuthorityContext(dataval.authority_context);
    }
  };

  useEffect(() => {
    AccessbilityScoreDetail();
  }, []);

  const downloadPdfAndCsv = async (download) => {
    setLoading(true);
    try {
      SetDetailRunReportPopShow(false);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}customized_report/ai_readiness_report_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=${download}&id=${ItemId}&timezone=${timezoneval()}`,
        { method: 'GET', headers: { 'Content-Type': `application/${download}`, Authorization: `${ApiToken}` } }
      );
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        const filedata = await Commonfun("AIReadliness", download, ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } else {
        toast.error("No Data", { position: "top-center", autoClose: 5000, theme: "light" });
      }
    } catch (error) {
      toast.error("No Data", { position: "top-center", autoClose: 5000, theme: "light" });
    }
    setLoading(false);
  };

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      {loading === true ? <Loader /> : null}

      <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">Ai Readiness Detail Report</h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: ' Ai Readiness', activeColor: true, link: '/ai-readiness' },
                      { title: ' Ai Readiness Detail Report', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <span>
                  <a target="_blank" href={linkUrl}>
                    <span style={{ display: 'inline-block' }} className="spanlink">{linkUrl}</span>
                  </a>
                </span><br />
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div style={{ display: "block", textAlign: "end", marginTop: "10px" }}>
                <div className="dashboard_download" style={{ justifyContent: "end", display: "inline-flex", cursor: "pointer" }} onClick={isDownloading ? null : () => downloadPdfAndCsv('pdf')}>
                  Download PDF
                  <svg className="filter" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">

            {/* ── Crawlability ── */}
            <Grid item xs={12} md={12}>
              <h2>Crawlability</h2>
              <div id="performance-metric">
                <div className="performance_accordion_div">
                  <AccordionRow panelId="crawl_llm_txt_exists" label="LLM Txt Exists" data={crawlabilityData?.llm_txt_exists} {...rowProps('crawl_llm_txt_exists')} />
                  <AccordionRow panelId="crawl_ai_bots_allowed" label="AI Bots Allowed" data={crawlabilityData?.ai_bots_allowed} {...rowProps('crawl_ai_bots_allowed')} />
                  <AccordionRow panelId="crawl_robots_txt_exists" label="Robots Txt Exists" data={crawlabilityData?.robots_txt_exists} {...rowProps('crawl_robots_txt_exists')} />
                  <AccordionRow panelId="crawl_sitemap_xml_exists" label="Sitemap XML Exists" data={crawlabilityData?.sitemap_xml_exists} {...rowProps('crawl_sitemap_xml_exists')} />
                  <AccordionRow panelId="crawl_sitemap_listed_in_robots" label="Sitemap Listed In Robots" data={crawlabilityData?.sitemap_listed_in_robots} {...rowProps('crawl_sitemap_listed_in_robots')} />
                </div>
              </div>
            </Grid>

            {/* ── Semantic Structure ── */}
            <Grid item xs={12} md={12}>
              <h2>Semantic Structure</h2>
              <div id="performance-metric">
                <div className="performance_accordion_div">
                  <AccordionRow panelId="sem_main_tag_exists" label="Main Tag Exists" data={semanticStructure?.main_tag_exists} {...rowProps('sem_main_tag_exists')} />
                  <AccordionRow panelId="sem_footer_tag_exists" label="Footer Tag Exists" data={semanticStructure?.footer_tag_exists} {...rowProps('sem_footer_tag_exists')} />
                  <AccordionRow panelId="sem_header_tag_exists" label="Header Tag Exists" data={semanticStructure?.header_tag_exists} {...rowProps('sem_header_tag_exists')} />
                  <AccordionRow panelId="sem_single_h1_present" label="Single H1 Present" data={semanticStructure?.single_h1_present} {...rowProps('sem_single_h1_present')} />
                  <AccordionRow panelId="sem_valid_heading_order" label="Valid Heading Order" data={semanticStructure?.valid_heading_order} {...rowProps('sem_valid_heading_order')} />
                </div>
              </div>
            </Grid>

            {/* ── Content Clarity ── */}
            <Grid item xs={12} md={12}>
              <h2>Content Clarity</h2>
              <div id="performance-metric">
                <div className="performance_accordion_div">
                  <AccordionRow panelId="cc_word_count_300" label="Word Count" data={contentClarity?.word_count_300} {...rowProps('cc_word_count_300')} />
                  <AccordionRow panelId="cc_content_chunking" label="Content Chunking" data={contentClarity?.content_chunking} {...rowProps('cc_content_chunking')} />
                  <AccordionRow panelId="cc_paragraph_length" label="Paragraph Length" data={contentClarity?.paragraph_length} {...rowProps('cc_paragraph_length')} />
                  <AccordionRow panelId="cc_title_tag_exists" label="Title Tag Exists" data={contentClarity?.title_tag_exists} {...rowProps('cc_title_tag_exists')} />
                  <AccordionRow panelId="cc_ai_extractability" label="AI Extractability" data={contentClarity?.ai_extractability} {...rowProps('cc_ai_extractability')} />
                  <AccordionRow panelId="cc_content_uniqueness" label="Content Uniqueness" data={contentClarity?.content_uniqueness} {...rowProps('cc_content_uniqueness')} />
                  <AccordionRow panelId="cc_answer_completeness" label="Answer Completeness" data={contentClarity?.answer_completeness} {...rowProps('cc_answer_completeness')} />
                  <AccordionRow panelId="cc_engagement_readiness" label="Engagement Readiness" data={contentClarity?.engagement_readiness} {...rowProps('cc_engagement_readiness')} />
                  <AccordionRow panelId="cc_above_the_fold_clarity" label="Above The Fold Clarity" data={contentClarity?.above_the_fold_clarity} {...rowProps('cc_above_the_fold_clarity')} />
                  <AccordionRow panelId="cc_direct_answer_presence" label="Direct Answer Presence" data={contentClarity?.direct_answer_presence} {...rowProps('cc_direct_answer_presence')} />
                  <AccordionRow panelId="cc_meta_description_exists" label="Meta Description Exists" data={contentClarity?.meta_description_exists} {...rowProps('cc_meta_description_exists')} />
                  <AccordionRow panelId="cc_search_intent_alignment" label="Search Intent Alignment" data={contentClarity?.search_intent_alignment} {...rowProps('cc_search_intent_alignment')} />
                  <AccordionRow panelId="cc_content_format_diversity" label="Content Format Diversity" data={contentClarity?.content_format_diversity} {...rowProps('cc_content_format_diversity')} />
                </div>
              </div>
            </Grid>

            {/* ── Structured Data ── */}
            <Grid item xs={12} md={12}>
              <h2>Structured Data</h2>
              <div id="performance-metric">
                <div className="performance_accordion_div">
                  <AccordionRow panelId="sd_faq_schema" label="FAQ Schema" data={structuredData?.faq_schema} {...rowProps('sd_faq_schema')} />
                  <AccordionRow panelId="sd_valid_json_ld" label="Valid JSON-LD" data={structuredData?.valid_json_ld} {...rowProps('sd_valid_json_ld')} />
                  <AccordionRow panelId="sd_organization_schema" label="Organization Schema" data={structuredData?.organization_schema} {...rowProps('sd_organization_schema')} />
                  <AccordionRow panelId="sd_schema_markup_present" label="Schema Markup Present" data={structuredData?.schema_markup_present} {...rowProps('sd_schema_markup_present')} />
                </div>
              </div>
            </Grid>

            {/* ── Page Rendering ── */}
            <Grid item xs={12} md={12}>
              <h2>Page Rendering</h2>
              <div id="performance-metric">
                <div className="performance_accordion_div">
                  <AccordionRow panelId="pr_rendering" label="Rendering" data={pageRendering?.rendering} {...rowProps('pr_rendering')} />
                  <Accordion expanded={expanded.includes('pr_page_speed')} onChange={() => handleChange('pr_page_speed')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="pr_page_speed-content" id="pr_page_speed-header">
                      <Typography sx={{ width: '33%', flexShrink: 0 }}>Page Speed</Typography>
                      <Typography sx={{ color: 'text.secondary', flex: 1 }}>{pageRendering?.page_speed?.message}</Typography>
                      <Typography sx={{ color: 'text.secondary', marginLeft: 'auto', paddingLeft: '16px' }}>
                        {pageRendering?.page_speed?.result
                          ? <img src={trueimages} className="view_per_img" alt="pass" />
                          : <img src={failimages} className="view_per_img" alt="fail" />
                        }
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {renderDetailReport(pageRendering?.page_speed?.detail_report, pageRendering?.page_speed?.metrics)}
                    </AccordionDetails>
                  </Accordion>
                  <AccordionRow panelId="pr_homepage_status_200" label="Homepage Status" data={pageRendering?.homepage_status_200} {...rowProps('pr_homepage_status_200')} />
                  <AccordionRow panelId="pr_canonical_tag_exists" label="Canonical Tag Exists" data={pageRendering?.canonical_tag_exists} {...rowProps('pr_canonical_tag_exists')} />
                  <AccordionRow panelId="pr_html_content_present" label="HTML Content Present" data={pageRendering?.html_content_present} {...rowProps('pr_html_content_present')} />
                  <AccordionRow panelId="pr_meta_robots_indexable" label="Meta Robots Indexable" data={pageRendering?.meta_robots_indexable} {...rowProps('pr_meta_robots_indexable')} />
                </div>
              </div>
            </Grid>

            {/* ── Authority Context ── */}
            <Grid item xs={12} md={12}>
              <h2>Authority Context</h2>
              <div id="performance-metric">
                <div className="performance_accordion_div">
                  <AccordionRow panelId="ac_eeat_signals" label="EEAT Signals" data={authorityContext?.eeat_signals} {...rowProps('ac_eeat_signals')} />
                  <AccordionRow panelId="ac_internal_linking" label="Internal Linking" data={authorityContext?.internal_linking} {...rowProps('ac_internal_linking')} />
                  <AccordionRow panelId="ac_external_references" label="External References" data={authorityContext?.external_references} {...rowProps('ac_external_references')} />
                </div>
              </div>
            </Grid>

          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand"> Elite site Optimizer</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

export default AiReadinessDetail;
